import { Button, Checkbox, Form, Modal } from 'antd'
import React from 'react'

const CompanyWorkScheduleConfirmSendNotificaitonModal = ({
  visible,
  onConfirm,
  onCancel,
  isLoading,
}) => {
  const [form] = Form.useForm()

  return (
    <Modal
      wrapClassName="custom-modal-wrapper"
      title="Cập nhật lịch công tác"
      visible={visible}
      onCancel={onCancel}
      footer={null}
      destroyOnClose
      confirmLoading={isLoading}>
      <p>Bạn có muốn cập nhật lịch công tác này không?</p>
      <Form form={form} onFinish={onConfirm}>
        <Form.Item
          name="is_notification_required"
          initialValue={true}
          valuePropName="checked">
          <Checkbox>Gửi thông báo</Checkbox>
        </Form.Item>

        <div className="custom-modal-footer">
          <Button className="custom-ant-button w-160" onClick={onCancel}>
            Hủy
          </Button>
          <Button
            className="custom-ant-button w-160"
            type={'primary'}
            htmlType={'submit'}
            loading={isLoading}>
            Xác nhận
          </Button>
        </div>
      </Form>
    </Modal>
  )
}

export default CompanyWorkScheduleConfirmSendNotificaitonModal
